import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import GenerateButton from "@/components/AccountParts/GenerateButton.vue"
import { generatePassword } from "@/services/functions"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordGenerate',
  props: {
    modelValue: {},
    buttonName: {},
    driverId: {},
    class: {}
  },
  emits: ['update:modelValue', 'displayError'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const passwordGenerationErrorMessage: string[] = [i18n.global.t('pages.accounts.messages.passwordGenerationError')]

function makePassword() {
  if (!props.driverId) return emits('displayError', passwordGenerationErrorMessage)
  const password = generatePassword(props.driverId)
  emits("update:modelValue",  password)
  emits('displayError', [])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.class)
  }, [
    _createVNode(GenerateButton, {
      buttonName: props.buttonName,
      onGenerate: makePassword
    }, null, 8, ["buttonName"])
  ], 2))
}
}

})